import React from 'react'
import { useStoreContext } from '../contexts/store-context'
import ArrowIconMinimal from './Icons/ArrowIconMinimal'
import { IcaInputSearch } from './IcaElements/IcaInputSearch'
import { IcaCardRow } from './IcaElements/IcaCardRow'

const SelectStore = () => {
  const { storeState, storeReducer } = useStoreContext()

  const [isOpen, setIsOpen] = React.useState(false)
  const [search, setSearch] = React.useState<string>('')

  const storeDropdownRef = React.useRef<HTMLDivElement | null>(null)
  const storeDropdownToggleRef = React.useRef<HTMLDivElement | null>(null)
  const selectedStoreRef = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (storeDropdownRef.current && !storeDropdownRef.current.contains(event.target as HTMLDivElement) && storeDropdownToggleRef.current && !storeDropdownToggleRef.current.contains(event.target as HTMLDivElement)) {
        setIsOpen(false)
        setSearch('')
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  // Make sure the selected store is visible at the top when opening the dropdown
  React.useEffect(() => {
    if (isOpen && selectedStoreRef.current) {
      const selected = selectedStoreRef.current
      selected.scrollIntoView({ block: 'start' })
    }
  }, [isOpen])

  const filteredStores = React.useMemo(() => {
    return storeState.availableStores?.filter((store) => store.name.toLowerCase().includes(search.toLowerCase())) ?? []
  }, [storeState.availableStores, search])

  const handleSearchChanged = (e: React.FormEvent<HTMLInputElement>) => {
    setSearch(e.currentTarget.value)
  }
  const handleSearchClear = () => {
    setSearch('')
  }

  const onSelect = (selectedStoreId: string) => {
    const newSelectedStore = storeState.availableStores.find((store) => store.id === selectedStoreId) ?? null
    if (newSelectedStore) {
      storeReducer.setSelectedStore(newSelectedStore)
      setIsOpen(false)
      setSearch('')
    }
  }

  return (
    <div className='select-store relative'>
      <div
        ref={storeDropdownToggleRef}
        className='select-store__dropdown'
        onClick={() => setIsOpen(() => !isOpen)}
      >
        <p className='select-store__store-name'>
          {storeState.selectedStore ? storeState.selectedStore.name : ''}
        </p>
        <span
          className={`select-store__arrow-icon${isOpen ? '--open' : '--closed'}`}
        >
          <ArrowIconMinimal direction='down' size='20px' color='var(--select-header-color)' />
        </span>
      </div>

      {isOpen && (
        <div
          ref={storeDropdownRef}
          className='select-store__dropdown-list'
        >
          <div className='p-[10px] shadow-[inset_0_-1px_0_0_#ebebeb]'>
            <IcaInputSearch
              label='Sök på butik eller site'
              value={search}
              onInput={handleSearchChanged}
              onClear={handleSearchClear}
            />
          </div>
          <div className='overflow-y-auto h-[400px]'>
            {filteredStores.length === 0 && <div className='p-2.5 text-center mt-7 text-[color:var(--color-dark-gray)]'>Inga butiker eller siter matchar sökningen</div>}
            {filteredStores.map((store) => {
              const isSelected = store.id === storeState.selectedStore?.id

              return (
                <IcaCardRow
                  key={`store-option-${store.id}`}
                  onClick={() => onSelect(store.id)}
                  ref={isSelected ? selectedStoreRef : null}
                  focused={isSelected}
                >
                  <>
                    <span className={`${isSelected ? 'font-semibold' : ''}`}>{store.name}</span>
                    {isSelected ? <tgdb-ica-icon-success style={{ color: '#007A1D' }}/> : null}
                  </>
                </IcaCardRow>
              )
              
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default SelectStore